import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  :root {
    --color-primary: #4CAF50;
    --color-primary-light: #81C784;
    --color-primary-dark: #388E3C;
    --color-primary-rgb: 76, 175, 80;
    --color-background: #FFFFFF;
    --color-text: #333333;
    --color-text-light: #666666;
    --color-accent: #2196F3;
    --gradient-primary: linear-gradient(135deg, var(--color-primary-light) 0%, var(--color-primary) 100%);
    --shadow-card: 0 8px 32px 0 rgba(31, 38, 135, 0.15);
    --shadow-card-hover: 0 12px 40px 0 rgba(31, 38, 135, 0.25);
    --shadow-button: 0 4px 12px rgba(0, 0, 0, 0.1);
    --border-radius: 12px;
    --spacing-unit: 8px;
    --transition-speed: 0.3s;
    --font-weight-normal: 400;
    --font-weight-medium: 500;
    --font-weight-bold: 700;
  }

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html, body {
    font-family: 'Quicksand', sans-serif;
    font-size: 16px;
    line-height: 1.5;
    color: var(--color-text);
    background: var(--color-background);
    scroll-behavior: smooth;
  }

  section {
    min-height: 100vh;
    background-color: var(--color-background);
    padding: 2rem;
    transition: all var(--transition-speed) ease;
  }

  h1, h2, h3, h4, h5, h6 {
    font-weight: 700;
    line-height: 1.2;
    margin-bottom: calc(var(--spacing-unit) * 2);
    color: var(--color-text);
  }

  p {
    margin-bottom: var(--spacing-unit);
    color: var(--color-text);
  }

  a {
    color: var(--color-accent);
    text-decoration: none;
    transition: color 0.3s ease;

    &:hover {
      color: var(--color-primary);
    }
  }

  button {
    font-family: 'Quicksand', sans-serif;
    cursor: pointer;
    border: none;
    outline: none;
    background: none;
  }

  ul, ol {
    list-style-position: inside;
    margin-bottom: var(--spacing-unit);
  }

  img {
    max-width: 100%;
    height: auto;
  }

  .glass-effect {
    background: rgba(255, 255, 255, 0.7);
    backdrop-filter: blur(8px);
    -webkit-backdrop-filter: blur(8px);
    border: 1px solid rgba(255, 255, 255, 0.3);
    box-shadow: var(--shadow-card);
  }

  .fade-enter {
    opacity: 0;
    transform: translateY(20px);
  }

  .fade-enter-active {
    opacity: 1;
    transform: translateY(0);
    transition: opacity var(--transition-speed) ease,
                transform var(--transition-speed) ease;
  }

  .fade-exit {
    opacity: 1;
    transform: translateY(0);
  }

  .fade-exit-active {
    opacity: 0;
    transform: translateY(-20px);
    transition: opacity var(--transition-speed) ease,
                transform var(--transition-speed) ease;
  }
`;

export default GlobalStyles;
